module.exports = __webpack_public_path__ + "55a656b7bfb06525f80ef2181bd8618f.jpg";